<div class="modal-header container-md" id="modal-header">
    <div class="col-4"></div>
    <div class="col-4">
      <img id="modal-memorabid-logo" src="/assets/img/memorabid-logo-white.svg" alt="MEMORABID">
    </div>
    <div class="col-3"></div>
    <div class="col-1">
      <button id="closeButton" type="button" class="close" aria-label="Close" (click)="activeModal.close(0)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
</div>
<div class="modal-body mx-3">
    <div>
        <h4 *ngIf="winnerUsername" class="text-uppercase">{{'IDS_MAKE_DIRECT_OFFER_TO' | translate}}{{winnerUsername}}</h4>
        <h4 *ngIf="!winnerUsername && !isMemorabid" class="text-uppercase">{{'IDS_MAKE_DIRECT_OFFER_TO' | translate}}{{entitySellerName}}</h4>
        <h4 *ngIf="!winnerUsername && isMemorabid" class="text-uppercase">{{'IDS_MAKE_DIRECT_OFFER_TO' | translate}}{{'IDS_MEMORABID' | translate}}</h4>
    </div>
    <div class="mt-3">
        <label class="fw-bold pb-2">{{'IDS_OBJECT' | translate}}</label>
        <div class="d-flex">
            <img class="image me-3" [src]="auctionPhoto + '?w=110'">
            <div>
                <p class="text-uppercase"><b>{{title()}}</b></p>
                <div class="d-flex flex-wrap auction-property">
                    <p *ngIf="sportIds">{{ sportIds | translate }}<span *ngIf="competitionIds || teamIds">&nbsp;|&nbsp;</span></p>
                    <p *ngIf="competitionIds">{{ competitionIds | translate }}<span *ngIf="teamIds">&nbsp;|&nbsp;</span></p>
                    <p *ngIf="teamIds">{{ teamIds | translate }}</p>
                    <div *ngFor="let property of article().articlePropertyList">
                        <div *ngIf="property.value && property.value != 'false' && property.name != 'Sport' && property.name != 'Competizione' && property.name != 'Squadra'">
                            <p *ngIf="property.value != 'true'">&nbsp;| {{ property.value }}</p>
                            <p *ngIf="property.value == 'true'">&nbsp;| {{'IDS_SIGNED' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <label class="fw-bold pb-2">{{'IDS_MESSAGE' | translate}}</label>
        <p>{{'IDS_OFFER_DIALOG_INTERESTED' | translate}}<b>"{{title()}}"</b>.</p>
        <p>{{'IDS_OFFER_DIALOG_YOU' | translate}}</p>
    </div>
    <div class="box-offer d-flex mx-auto mt-3">
        <input
            type="text"
            id="offeredPrice"
            class="form-control price-offered mx-auto"
            [(ngModel)]="offeredPrice"
            name="offeredPrice"
            mask="separator.0"
            thousandSeparator="."
            pattern="^[1-9]+[0-9]*$">
        <p class="price-offered-text my-auto">,00 €</p>
    </div>
    <p class="mt-3">{{'IDS_OFFER_DIALOG_SHIPPING_PRICE' | translate}}</p>

    <label class="text-muted label-container">
        <input class="input-checkbox" type="checkbox" name="terms-conditions" [(ngModel)]="acceptTermsCondition">
        {{'IDS_ACCEPT_THE' | translate}} <a class="terms-conditions" (click)="goToPage('/direct-bidding')">{{'IDS_TERMS_CONDITION' | translate}}</a>
        <span class="checkmark"></span>
    </label>

    <label
        *ngIf="showErrorString.length > 0"
        class="error-label d-flex justify-content-center">
        {{showErrorString | translate}}
    </label>

    <div class="d-flex justify-content-between mt-5">
        <p *ngIf="minPriceForOffer" class="minimum-price">{{'IDS_OFFER_DIALOG_MINIMUM' | translate}}{{minPriceForOffer}},00 €</p>
        <button
            type="submit"
            [ngClass]="{'btn-gold':isMemorabid, 'btn-marketplace':!isMemorabid}"
            class="btn-dialog text-uppercase fw-bold px-5"
            (click)="makeDirectOffer()">
            {{'IDS_SEND' | translate}}
        </button>
    </div>
</div>
